if (!customElements.get('enooso-card-goals')) {
  class EnoosoCardGoals extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest('.section-' + this.sectionId);
      this.wrapper = this.querySelector('.ecg-items');

      this.items = parseInt(this.dataset.items) || 4;
      this.tabletItems = parseInt(this.dataset.tabletItems) || Math.min(this.items, 4);
      this.gap = parseInt(this.dataset.gap) || 12;
      this.desktopSlider = this.dataset.desktopSlider === 'true';
      this.mobileSlider = this.dataset.mobileSlider === 'true';

      this.sliderInstance = null;

      if (!this.desktopSlider && !this.mobileSlider) return;

      this.mql = window.matchMedia('(min-width: 1024px)');
      this.decide = this.decide.bind(this);
      this.mql.addEventListener('change', this.decide);
      this.decide();

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          if (!this.sliderInstance || !this.sliderInstance.slider) return;
          const index = Number(e.target.dataset.index);
          if (!isNaN(index)) this.sliderInstance.slider.slideTo(index);
        });
      }
    }

    decide() {
      const shouldSlide = this.mql.matches ? this.desktopSlider : this.mobileSlider;
      if (shouldSlide && !this.sliderInstance) {
        this.initSlider();
      } else if (!shouldSlide && this.sliderInstance) {
        this.destroySlider();
      }
    }

    initSlider() {
      if (!window.FoxTheme || !FoxTheme.Carousel) return;

      const sliderOptions = {
        slidesPerView: 2,
        spaceBetween: this.gap,
        loop: false,
        threshold: 2,
        watchOverflow: true,
        breakpoints: {
          1024: { slidesPerView: this.tabletItems, spaceBetween: this.gap },
          1280: { slidesPerView: this.items, spaceBetween: this.gap },
        },
      };

      const nextEl = this.section.querySelector('.swiper-btn-next');
      const prevEl = this.section.querySelector('.swiper-btn-prev');
      if (nextEl && prevEl) {
        sliderOptions.navigation = { nextEl: nextEl, prevEl: prevEl };
      }

      const paginationEl = this.section.querySelector('.swiper-pagination');
      if (paginationEl) {
        sliderOptions.pagination = { el: paginationEl, clickable: true };
      }

      this.classList.add('swiper');
      this.wrapper.classList.add('swiper-wrapper');
      this.sliderInstance = new FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();
    }

    destroySlider() {
      if (this.sliderInstance && this.sliderInstance.slider) {
        this.sliderInstance.slider.destroy(true, true);
      }
      this.sliderInstance = null;
      this.classList.remove('swiper');
      this.wrapper.classList.remove('swiper-wrapper');
    }

    disconnectedCallback() {
      if (this.mql) this.mql.removeEventListener('change', this.decide);
    }
  }
  customElements.define('enooso-card-goals', EnoosoCardGoals);
}
